import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { OnboardingLayout } from '../Layout';
import { ListItem } from '@/components/ui/ListItem';
import { paths } from '@/routes/paths';
import type { FamilyRole } from '@/api/types';

const ROLES: FamilyRole[] = [
  'brother',
  'daughter',
  'father',
  'husband',
  'mother',
  'sister',
  'son',
  'wife',
];

export function OnboardingFamilyRolePage(): JSX.Element {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <OnboardingLayout back title={t('onboarding.family_form.role.label')}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {ROLES.map((r) => (
          <ListItem
            key={r}
            title={t(`family_member.role.${r}`)}
            onClick={() => navigate(paths.onboardingFamilyForm, { state: { presetRole: r } })}
          />
        ))}
      </div>
    </OnboardingLayout>
  );
}
